import BreadCrump from "../tools/breadcrump"
import { getCookies } from "cookies-next";
import { useEffect, useState, type ReactNode } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import changeUrl from "../../hoc/changeur";
import { config } from "../../data/config";
import { useTranslation } from 'react-i18next';
import { QRCodeCanvas } from 'qrcode.react';
import HeaderOfPage from "../tools/headerOfPage";
import PlusIcon from "@rsuite/icons/Plus";
import CloseIcon from "@rsuite/icons/Close";

const emptyProduct = {
    name: '',
    url: '',
    keywords: '',
    description: '',
    parent: null as string | null,
    code: '',
    alt: '',
    mainprice: null as string | number | null,
    isExisting: true,
    unlimitedStock: true,
    stockCount: 0,
};

export default function ListPr() {
    const { t } = useTranslation();
    const [key, setKey] = useState(1);
    const [createOpen, setCreateOpen] = useState(false);

    const breadcrump = [
        { name: 'Dashboard', url: '/dashboard' },
        { name: 'Products', url: '/dashboard/Products' },
        { name: 'List Products', url: null },
    ];

    const reloadgame = () => {
        setKey((x) => x + 1);
        setCreateOpen(false);
    };

    return (
        <div className="m-4 mb-5 rounded-xl border border-gray-100 bg-white p-3 shadow-sm sm:p-4">
            <BreadCrump data={breadcrump}></BreadCrump>
            <HeaderOfPage name="List Products"></HeaderOfPage>

            <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
                <p className="text-sm text-slate-500">مدیریت و فیلتر محصولات فروشگاه</p>
                <button
                    type="button"
                    onClick={() => setCreateOpen(true)}
                    className="inline-flex items-center gap-2 rounded-lg bg-slate-900 px-4 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:bg-slate-800"
                >
                    <PlusIcon className="text-[14px]" />
                    {t('محصول جدید')}
                </button>
            </div>

            <div className="directions">
                <ListofProducts key={key} />
            </div>

            <NewProductDrawer
                open={createOpen}
                onClose={() => setCreateOpen(false)}
                reloaditem={reloadgame}
            />
        </div>
    );
}

function ListofProducts() {
    const { t } = useTranslation();

    const cookie = getCookies();
    const [list, setList] = useState<any>(null);
    const [name, setName] = useState('');
    const [group, setGroup] = useState('');
    const [listgroup, setListArticle] = useState<any>(null);
    const [loading, setLoading] = useState(true);

    const loaddata = async (page = 1) => {
        setLoading(true);
        try {
            const res = await axios({
                method: 'get',
                url: `${config.url}/v1/dashboard/pproducts?page=${page}&name=${name}&group=${group}`,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            setList(res.data.message);
        } catch (error) {
            // ignore
        } finally {
            setLoading(false);
        }
    }

    const getalldata = async () => {
        try {
            const res = await axios({
                method: 'get',
                url: config.url + '/v1/dashboard/pgroup',
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            })
            setListArticle(res.data.message);
        } catch (error) {
        }
    }

    const deleted = async (id: any) => {
        Swal.fire({
            title: t("Are you sure?"),
            text: t("Delete this Post!"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: t('Yes, delete it')
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await axios({
                        method: 'delete',
                        url: config.url + '/v1/dashboard/pproducts/' + id,
                        headers: {
                            Authorization: 'Bearer ' + cookie['token'],
                        }
                    })
                    loaddata(1);
                } catch (error) {
                }
            }
        });
    }

    useEffect(() => {
        loaddata(1);
        getalldata();
    }, []);

    const docs = list?.docs ?? [];

    const productBadges = (item: any) => {
        const badges: { label: string; className: string }[] = [];
        if (item.firstpage == 1) badges.push({ label: 'ویژه', className: 'bg-amber-50 text-amber-700 ring-amber-200' });
        if (item.special == 1) badges.push({ label: 'پرفروش', className: 'bg-emerald-50 text-emerald-700 ring-emerald-200' });
        if (item.special1 == 1) badges.push({ label: 'نانو', className: 'bg-sky-50 text-sky-700 ring-sky-200' });
        if (item.special2 == 1) badges.push({ label: 'آبگریزها', className: 'bg-violet-50 text-violet-700 ring-violet-200' });
        return badges;
    };

    return (
        <div className="directions text-right" dir="rtl">
            <div className="mb-4 grid grid-cols-1 gap-3 rounded-xl border border-gray-100 bg-gray-50/60 p-3 sm:grid-cols-5 sm:items-end">
                <div className="sm:col-span-2">
                    <label className="mb-1 block text-xs font-medium text-gray-500">{t("Slug")}</label>
                    <input
                        onChange={(e) => setName(e.target.value)}
                        onKeyDown={(e) => { if (e.key === 'Enter') loaddata(1); }}
                        className="w-full rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm text-gray-700 shadow-sm focus:border-gray-300 focus:outline-none"
                        type="text"
                        placeholder="Search"
                    />
                </div>
                <div className="sm:col-span-2">
                    <label className="mb-1 block text-xs font-medium text-gray-500">{t('Select Group')}</label>
                    <select
                        onChange={(e) => setGroup(e.target.value)}
                        className="w-full rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm text-gray-700 shadow-sm focus:border-gray-300 focus:outline-none"
                    >
                        <option value="">{t('Select Group')}</option>
                        {listgroup != null && listgroup.map((item: any) => (
                            <optgroup label={item.name} key={item.id}>
                                <option value={item.id}>{item.name}</option>
                                {item.togroup != undefined && item.togroup.map((p: any) => (
                                    <option key={p.id} value={p.id}>{p.name}</option>
                                ))}
                            </optgroup>
                        ))}
                    </select>
                </div>
                <div className="sm:col-span-1">
                    <button
                        onClick={() => loaddata(1)}
                        className="w-full rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-semibold text-gray-800 shadow-sm transition hover:bg-gray-100"
                    >
                        {t('Filter')}
                    </button>
                </div>
            </div>

            {loading && (
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
                    {[1, 2, 3, 4, 5, 6].map((i) => (
                        <div key={i} className="h-[168px] animate-pulse rounded-xl border border-gray-100 bg-gray-50" />
                    ))}
                </div>
            )}

            {!loading && docs.length === 0 && (
                <div className="flex flex-col items-center justify-center rounded-xl border border-dashed border-gray-200 bg-gray-50/50 px-4 py-16">
                    <p className="text-sm font-medium text-gray-700">محصولی یافت نشد</p>
                    <p className="mt-1 text-xs text-gray-500">با فیلتر دیگر جستجو کنید یا محصول جدید بسازید</p>
                </div>
            )}

            {!loading && docs.length > 0 && (
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
                    {docs.map((item: any) => {
                        const badges = productBadges(item);
                        const accent =
                            item.firstpage == 1
                                ? 'border-r-amber-400'
                                : item.special == 1
                                    ? 'border-r-emerald-400'
                                    : 'border-r-slate-300';

                        return (
                            <div
                                key={item.id}
                                className={`group flex h-full flex-col overflow-hidden rounded-xl border border-gray-100 border-r-4 bg-white shadow-sm transition-all duration-200 hover:border-gray-200 hover:shadow-md ${accent}`}
                            >
                                <div className="flex flex-1 flex-col gap-3 p-4">
                                    <div className="flex items-start justify-between gap-3">
                                        <div className="min-w-0 flex-1 text-right">
                                            <h3 className="truncate text-sm font-semibold text-gray-900">
                                                {item.name}
                                            </h3>
                                            <p className="mt-1 truncate font-mono text-xs tracking-wide text-gray-500" dir="ltr">
                                                /{item.url}
                                            </p>
                                        </div>
                                        <div className="h-12 w-12 shrink-0 overflow-hidden rounded-lg border border-gray-100 bg-white p-1">
                                            <QRCodeCanvas
                                                size={48}
                                                value={`https://nanosealco.com/detail/${item.url}`}
                                                style={{ width: '100%', height: '100%' }}
                                            />
                                        </div>
                                    </div>

                                    {badges.length > 0 && (
                                        <div className="flex flex-wrap gap-1.5">
                                            {badges.map((badge) => (
                                                <span
                                                    key={badge.label}
                                                    className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold ring-1 ${badge.className}`}
                                                >
                                                    {badge.label}
                                                </span>
                                            ))}
                                        </div>
                                    )}

                                    <div className="mt-auto grid grid-cols-2 gap-3 border-t border-gray-100 pt-3">
                                        <div className="text-right">
                                            <p className="mb-0.5 text-[11px] text-gray-400">{t('Group')}</p>
                                            <p className="truncate text-sm font-medium text-gray-800">
                                                {item.toGroup?.name || '—'}
                                            </p>
                                        </div>
                                        <div className="text-right">
                                            <p className="mb-0.5 text-[11px] text-gray-400">قیمت پایه</p>
                                            <p className="text-sm font-bold tabular-nums text-gray-900">
                                                {item.mainprice != null
                                                    ? Number(item.mainprice).toLocaleString('fa-IR')
                                                    : '—'}
                                                {item.mainprice != null && (
                                                    <span className="mr-1 text-[11px] font-medium text-gray-500">تومان</span>
                                                )}
                                            </p>
                                        </div>
                                    </div>

                                    <div className="flex items-center justify-between gap-2 border-t border-gray-50 pt-2">
                                        <a
                                            href={`/dashboard/Products/Products/${item.id}`}
                                            className="inline-flex items-center gap-1.5 text-xs font-medium text-gray-400 transition-colors group-hover:text-blue-600"
                                        >
                                            <span>ویرایش محصول</span>
                                            <svg className="size-3.5 transition-transform group-hover:-translate-x-0.5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                <path d="m15 18-6-6 6-6" />
                                            </svg>
                                        </a>
                                        <div className="flex items-center gap-1.5">
                                            <a
                                                href={`/dashboard/Products/Label/${item.id}`}
                                                className="inline-flex h-8 w-8 items-center justify-center rounded-lg border border-gray-100 bg-gray-50 transition hover:bg-blue-50"
                                                title="Label"
                                            >
                                                <img src="/label.svg" alt="Label" className="h-4 w-4" />
                                            </a>
                                            <a
                                                href={`/dashboard/Products/Products/${item.id}`}
                                                className="inline-flex h-8 w-8 items-center justify-center rounded-lg border border-gray-100 bg-gray-50 transition hover:bg-emerald-50"
                                                title="Edit"
                                            >
                                                <img src="/icons/editgreen.svg" alt="Edit" className="h-4 w-4" />
                                            </a>
                                            <button
                                                onClick={() => deleted(item.id)}
                                                type="button"
                                                className="inline-flex h-8 w-8 items-center justify-center rounded-lg border border-gray-100 bg-gray-50 transition hover:bg-rose-50"
                                                title="Delete"
                                            >
                                                <img src="/icons/delred.svg" alt="Del" className="h-4 w-4" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}

            {list != null && list.totalPages > 1 && (
                <div className="mt-6 flex justify-center">
                    <nav className="flex items-center -space-x-px" aria-label="Pagination">
                        {list.prevPage != null && (
                            <button
                                onClick={() => loaddata(list.page - 1)}
                                type="button"
                                className="inline-flex min-h-[38px] min-w-[38px] items-center justify-center gap-x-1.5 border border-gray-200 px-2.5 py-2 text-sm text-gray-800 first:rounded-s-lg last:rounded-e-lg hover:bg-gray-100 focus:bg-gray-100 focus:outline-none disabled:pointer-events-none disabled:opacity-50"
                                aria-label="Previous"
                            >
                                <svg className="size-3.5 shrink-0" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="m15 18-6-6 6-6"></path>
                                </svg>
                                <span className="hidden sm:block">{t('Previous')}</span>
                            </button>
                        )}
                        {Array.from({ length: list.totalPages }, (_, index) => index + 1).map((item) => (
                            list.page == item ? (
                                <button
                                    key={item}
                                    type="button"
                                    className="flex min-h-[38px] min-w-[38px] items-center justify-center border border-gray-200 bg-gray-200 px-3 py-2 text-sm text-gray-800 first:rounded-s-lg last:rounded-e-lg focus:bg-gray-300 focus:outline-none"
                                    aria-current="page"
                                >
                                    {item}
                                </button>
                            ) : (
                                <button
                                    key={item}
                                    onClick={() => loaddata(item)}
                                    type="button"
                                    className="flex min-h-[38px] min-w-[38px] items-center justify-center border border-gray-200 px-3 py-2 text-sm text-gray-800 first:rounded-s-lg last:rounded-e-lg hover:bg-gray-100 focus:bg-gray-100 focus:outline-none"
                                >
                                    {item}
                                </button>
                            )
                        ))}
                        {list.nextPage != null && (
                            <button
                                onClick={() => loaddata(list.page + 1)}
                                type="button"
                                className="inline-flex min-h-[38px] min-w-[38px] items-center justify-center gap-x-1.5 border border-gray-200 px-2.5 py-2 text-sm text-gray-800 first:rounded-s-lg last:rounded-e-lg hover:bg-gray-100 focus:bg-gray-100 focus:outline-none disabled:pointer-events-none disabled:opacity-50"
                                aria-label="Next"
                            >
                                <span className="hidden sm:block">{t('Next')}</span>
                                <svg className="size-3.5 shrink-0" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="m9 18 6-6-6-6"></path>
                                </svg>
                            </button>
                        )}
                    </nav>
                </div>
            )}
        </div>
    )
}

function FieldLabel({ children }: { children: ReactNode }) {
    return <label className="mb-1.5 block text-xs font-medium text-slate-600">{children}</label>;
}

function FieldError({ message }: { message?: string }) {
    if (!message) return null;
    return <p className="mt-1 text-xs text-rose-600">{message}</p>;
}

function NewProductDrawer({
    open,
    onClose,
    reloaditem,
}: {
    open: boolean;
    onClose: () => void;
    reloaditem: () => void;
}) {
    const { t } = useTranslation();
    const cookie = getCookies();
    const [data, setData] = useState({ ...emptyProduct });
    const [list, setListArticle] = useState<any>(null);
    const [error, setError] = useState<any>(null);
    const [saving, setSaving] = useState(false);
    const [formKey, setFormKey] = useState(1);

    const inputClass =
        "w-full rounded-lg border border-slate-200 bg-white px-3 py-2.5 text-sm text-slate-800 shadow-sm outline-none transition focus:border-slate-400 focus:ring-2 focus:ring-slate-900/10";
    const inputError = "border-rose-300 bg-rose-50 focus:border-rose-400 focus:ring-rose-200/60";

    const setName = (name: string) => {
        setData((prev) => ({ ...prev, url: changeUrl(name), name }));
    };

    const resetForm = () => {
        setData({ ...emptyProduct });
        setError(null);
        setFormKey((k) => k + 1);
    };

    const save = async () => {
        setError(null);
        setSaving(true);
        try {
            await axios({
                method: 'post',
                url: config.url + '/v1/dashboard/pproducts',
                data,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            Swal.fire({
                icon: 'success',
                title: 'محصول ذخیره شد',
                timer: 1400,
                showConfirmButton: false,
            });
            resetForm();
            reloaditem();
        } catch (err: any) {
            err?.response?.data?.code != null && Swal.fire(` "${data.url}" slug is available.`);
            setError(err?.response?.data?.message?.errors);
        } finally {
            setSaving(false);
        }
    };

    useEffect(() => {
        const loadGroups = async () => {
            try {
                const res = await axios({
                    method: 'get',
                    url: config.url + '/v1/dashboard/pgroup',
                    headers: {
                        Authorization: 'Bearer ' + cookie['token'],
                    }
                });
                setListArticle(res.data.message);
            } catch (error) {
            }
        };
        loadGroups();
    }, []);

    useEffect(() => {
        if (!open) return;
        const onKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'Escape') onClose();
        };
        document.addEventListener('keydown', onKeyDown);
        document.body.style.overflow = 'hidden';
        return () => {
            document.removeEventListener('keydown', onKeyDown);
            document.body.style.overflow = '';
        };
    }, [open, onClose]);

    return (
        <div
            className={[
                'fixed inset-0 z-[60]',
                open ? 'pointer-events-auto' : 'pointer-events-none',
            ].join(' ')}
            aria-hidden={!open}
        >
            <button
                type="button"
                className={[
                    'absolute inset-0 bg-slate-950/45 transition-opacity duration-200',
                    open ? 'opacity-100' : 'opacity-0',
                ].join(' ')}
                aria-label="Close"
                onClick={onClose}
            />

            <aside
                className={[
                    'absolute inset-y-0 start-0 flex w-full max-w-xl flex-col bg-white shadow-2xl transition-transform duration-300 ease-out',
                    open
                        ? 'translate-x-0'
                        : t('dir') === 'rtl'
                            ? 'translate-x-full'
                            : '-translate-x-full',
                ].join(' ')}
                role="dialog"
                aria-modal="true"
                aria-label={t('محصول جدید')}
                dir="rtl"
            >
                <div className="flex items-start justify-between gap-3 border-b border-slate-100 px-5 py-4">
                    <div>
                        <h2 className="text-lg font-bold text-slate-900">{t('محصول جدید')}</h2>
                        <p className="mt-0.5 text-xs text-slate-500">اطلاعات اولیه محصول را وارد کنید</p>
                    </div>
                    <button
                        type="button"
                        onClick={onClose}
                        className="inline-flex h-9 w-9 items-center justify-center rounded-lg bg-slate-100 text-slate-600 transition hover:bg-slate-200"
                        aria-label="Close"
                    >
                        <CloseIcon className="text-[14px]" />
                    </button>
                </div>

                <form
                    key={formKey}
                    className="flex-1 space-y-5 overflow-y-auto px-5 py-5"
                    onSubmit={(e) => {
                        e.preventDefault();
                        save();
                    }}
                >
                    <section className="space-y-4 rounded-xl border border-slate-100 bg-slate-50/70 p-4">
                        <h3 className="text-sm font-semibold text-slate-800">اطلاعات اصلی</h3>
                        <div>
                            <FieldLabel>نام</FieldLabel>
                            <input
                                type="text"
                                className={`${inputClass} ${error?.name ? inputError : ''}`}
                                placeholder="نام محصول"
                                onChange={(e) => setName(e.target.value)}
                            />
                            <FieldError message={error?.name?.message} />
                        </div>
                        <div>
                            <FieldLabel>Slug</FieldLabel>
                            <input
                                value={data.url}
                                type="text"
                                dir="ltr"
                                className={`${inputClass} text-left ${error?.url ? inputError : ''}`}
                                placeholder="product-slug"
                                onChange={(e) => setData({ ...data, url: e.target.value })}
                            />
                            <FieldError message={error?.url?.message} />
                        </div>
                        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                            <div>
                                <FieldLabel>قیمت پایه</FieldLabel>
                                <input
                                    dir="ltr"
                                    value={data.mainprice ?? ''}
                                    type="number"
                                    className={`${inputClass} text-left`}
                                    placeholder="0"
                                    onChange={(e) => setData({ ...data, mainprice: e.target.value })}
                                />
                            </div>
                            <div>
                                <FieldLabel>کد</FieldLabel>
                                <input
                                    value={data.alt}
                                    type="text"
                                    className={inputClass}
                                    placeholder="کد محصول"
                                    onChange={(e) => setData({ ...data, alt: e.target.value })}
                                />
                            </div>
                        </div>
                        <div>
                            <FieldLabel>{t('Group')}</FieldLabel>
                            <select
                                onChange={(e) => setData({ ...data, parent: e.target.value })}
                                className={inputClass}
                                defaultValue=""
                            >
                                <option value="" disabled>{t('Choice Group')} ...</option>
                                {list != null && list.map((item: any) => (
                                    <optgroup label={item.name} key={item.id}>
                                        <option value={item.id}>{item.name}</option>
                                        {item.togroup?.map((p: any) => (
                                            <option key={p.id} value={p.id}>{p.name}</option>
                                        ))}
                                    </optgroup>
                                ))}
                            </select>
                        </div>
                    </section>

                    <section className="space-y-4 rounded-xl border border-slate-100 bg-slate-50/70 p-4">
                        <h3 className="text-sm font-semibold text-slate-800">موجودی</h3>
                        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                            <div>
                                <FieldLabel>وضعیت موجودی</FieldLabel>
                                <div className="grid grid-cols-2 gap-2">
                                    {[
                                        { value: true, label: 'موجود' },
                                        { value: false, label: 'ناموجود' },
                                    ].map((opt) => (
                                        <button
                                            key={String(opt.value)}
                                            type="button"
                                            onClick={() => setData({ ...data, isExisting: opt.value })}
                                            className={[
                                                'rounded-lg border px-3 py-2.5 text-sm font-medium transition',
                                                data.isExisting === opt.value
                                                    ? 'border-slate-900 bg-slate-900 text-white'
                                                    : 'border-slate-200 bg-white text-slate-600 hover:border-slate-300',
                                            ].join(' ')}
                                        >
                                            {opt.label}
                                        </button>
                                    ))}
                                </div>
                            </div>
                            <div>
                                <FieldLabel>نوع موجودی انبار</FieldLabel>
                                <div className="grid grid-cols-2 gap-2">
                                    {[
                                        { value: true, label: 'نامحدود' },
                                        { value: false, label: 'محدود' },
                                    ].map((opt) => (
                                        <button
                                            key={String(opt.value)}
                                            type="button"
                                            onClick={() => setData({
                                                ...data,
                                                unlimitedStock: opt.value,
                                                stockCount: opt.value ? 0 : (data.stockCount || 0),
                                            })}
                                            className={[
                                                'rounded-lg border px-3 py-2.5 text-sm font-medium transition',
                                                data.unlimitedStock === opt.value
                                                    ? 'border-slate-900 bg-slate-900 text-white'
                                                    : 'border-slate-200 bg-white text-slate-600 hover:border-slate-300',
                                            ].join(' ')}
                                        >
                                            {opt.label}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        </div>
                        {!data.unlimitedStock && (
                            <div>
                                <FieldLabel>تعداد موجود در انبار</FieldLabel>
                                <input
                                    dir="ltr"
                                    value={data.stockCount ?? 0}
                                    type="number"
                                    min={0}
                                    className={`${inputClass} text-left`}
                                    placeholder="0"
                                    onChange={(e) => setData({
                                        ...data,
                                        stockCount: Math.max(0, parseInt(e.target.value, 10) || 0),
                                    })}
                                />
                            </div>
                        )}
                    </section>

                    <section className="space-y-4 rounded-xl border border-slate-100 bg-slate-50/70 p-4">
                        <h3 className="text-sm font-semibold text-slate-800">سئو</h3>
                        <div>
                            <FieldLabel>{t('Keywords')}</FieldLabel>
                            <textarea
                                className={`${inputClass} min-h-[80px] resize-y`}
                                onChange={(e) => setData({ ...data, keywords: e.target.value })}
                                placeholder="کلمات کلیدی..."
                            />
                        </div>
                        <div>
                            <FieldLabel>{t('Description')}</FieldLabel>
                            <textarea
                                className={`${inputClass} min-h-[100px] resize-y`}
                                onChange={(e) => setData({ ...data, description: e.target.value })}
                                placeholder="توضیحات کوتاه..."
                            />
                        </div>
                    </section>
                </form>

                <div className="flex items-center justify-between gap-3 border-t border-slate-100 bg-white px-5 py-4">
                    <button
                        type="button"
                        onClick={onClose}
                        className="rounded-lg border border-slate-200 px-4 py-2.5 text-sm font-medium text-slate-600 transition hover:bg-slate-50"
                    >
                        انصراف
                    </button>
                    <button
                        type="button"
                        disabled={saving}
                        onClick={save}
                        className="inline-flex items-center gap-2 rounded-lg bg-slate-900 px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-slate-800 disabled:opacity-60"
                    >
                        {saving ? 'در حال ذخیره...' : t('Save')}
                    </button>
                </div>
            </aside>
        </div>
    );
}
